export default __webpack_public_path__ + "static/media/stamp4.9d0858d9.png";